import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, ShieldCheck } from "lucide-react";

export default function Setup() {
  const nav = useNavigate();
  const [name, setName] = useState("Mainakraga");
  const [email, setEmail] = useState("mainakraga@gmail.com");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("Password must be at least 8 characters");
    if (password !== confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/bootstrap", { name, email, password });
      toast.success("Super Admin created successfully");
      nav("/", { replace: true });
      window.location.reload();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-slate-50 dark:bg-[#0B0F17] items-center justify-center p-6">
      <div className="w-full max-w-md rounded-2xl border bg-white p-8 shadow-sm dark:border-slate-800 dark:bg-slate-900">
        <div className="mb-6 flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-amber-500 font-display font-extrabold text-lg text-slate-900">K</span>
          <div>
            <p className="font-display font-bold text-lg">Krishna Group</p>
            <p className="text-xs uppercase tracking-widest text-slate-400">Initial Administrator Setup</p>
          </div>
        </div>
        <div className="mb-6 rounded-xl bg-slate-50 p-4 dark:bg-slate-800/60">
          <div className="flex items-center gap-2 font-semibold"><ShieldCheck className="h-5 w-5" /> Create Super Admin</div>
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">This one-time setup is available only while the MySQL users table is empty. The account will receive access to all imported companies.</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div><Label htmlFor="setup-name">Name</Label><Input id="setup-name" value={name} onChange={e=>setName(e.target.value)} required className="mt-1.5 h-11" /></div>
          <div><Label htmlFor="setup-email">Email</Label><Input id="setup-email" type="email" value={email} onChange={e=>setEmail(e.target.value)} required className="mt-1.5 h-11" /></div>
          <div><Label htmlFor="setup-password">New password</Label><Input id="setup-password" type="password" autoComplete="new-password" value={password} onChange={e=>setPassword(e.target.value)} required minLength={8} className="mt-1.5 h-11" placeholder="At least 8 characters" /></div>
          <div><Label htmlFor="setup-confirm">Confirm password</Label><Input id="setup-confirm" type="password" autoComplete="new-password" value={confirm} onChange={e=>setConfirm(e.target.value)} required minLength={8} className="mt-1.5 h-11" /></div>
          <Button type="submit" disabled={busy} className="h-11 w-full bg-slate-900 hover:bg-slate-800 dark:bg-slate-100 dark:text-slate-900 font-semibold">
            {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Create Super Admin
          </Button>
        </form>
        <p className="mt-5 text-center text-xs text-slate-400"><button type="button" onClick={()=>nav('/login')} className="hover:underline">Back to sign in</button></p>
      </div>
    </div>
  );
}
